import Desktop from "./desktop";
import Mobile from "./mobile";

const ModalCompleteProfileCta = (props) => {

	const prop = props;

	if (prop.isMobile) {

		return <Mobile {...props} />;

	}
	return <Desktop {...props} />;

};

export default ModalCompleteProfileCta;
